import AddressOption from '@components/order/models/edit/AddressOption';
import DirectionsWalkRoundedIcon from '@mui/icons-material/DirectionsWalkRounded';
import { observer } from 'mobx-react-lite';
import React from 'react';
import AddressOptionListItem from './AddressOptionListItem';

interface ComingForOrderOptionListItemProps {
    selectedValue: AddressOption;
    setAddressOption: (addressOption: AddressOption) => void;
}

const ComingForOrderOptionListItem: React.FC<ComingForOrderOptionListItemProps> = observer(({ selectedValue, setAddressOption }) => {
    var isSelected = "isComingForOrder" === selectedValue;
    
    return (
        <AddressOptionListItem
            title={"Dolazim po narudžbu"}
            icon={<DirectionsWalkRoundedIcon color={isSelected ? "secondary" : "action"} />}
            value={"isComingForOrder"}
            selectedValue={selectedValue}
            onClick={setAddressOption} />
    )
})

export default ComingForOrderOptionListItem;